export default __webpack_public_path__ + "static/media/unstaking-step-three-cirus.feabddd3.png";